// Helper function to normalize strings
function handleize(str) {
  return str
    ? String(str)
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/-$/, '')
        .replace(/^-/, '')
    : '';
}

function normalizeMake(str) {
  const handle = handleize(str);
  if (handle === 'chevy' || handle === 'chevrolet' || handle === 'gm') return 'chevrolet';
  return handle;
}

function modelsMatch(modelA, modelB) {
  const first = handleize(modelA);
  const second = handleize(modelB);
  if (!first || !second) return false;
  if (first === second) return true;
  return first.startsWith(`${second}-`) || second.startsWith(`${first}-`);
}

function isHeadquarters(company) {
  const name = company?.name || '';
  const type = company?.type || '';
  return name === 'Super Pacific HQ' || type === 'Super Pacific HQ';
}

function hasVehicleSelection() {
  return Boolean(selectedMake || selectedModel || selectedVehicleType);
}

function getCompanyCardId(company) {
  const card = company?.element;
  if (!card) return '';
  return card.getAttribute('data-card-id') || card.getAttribute('data-marker-id') || '';
}

function getFilterMessages() {
  const container = document.getElementById('company-cards-container');
  return {
    similar:
      container?.dataset.similarTrucksMessage ||
      'An exact match was not found in this area. Here are some similar trucks.',
    none: container?.dataset.noMatchesMessage || 'No matches found for your current search radius.',
    expand: container?.dataset.expandSearchLabel || 'Expand search to 250 miles',
    showAll: container?.dataset.showAllLabel || 'Show all results',
  };
}

// Define global variables for selected filters
let selectedMake = null;
let selectedModel = null;
let selectedVehicleType = null;
let filterOptions = [];
let noExactMatchMessage = null;
window.userLocationMarker = null;
// let locationSearchActive = false;
let matchingCardIds = [];

// At the top of the file, add:
window.locationSearchResults = {
  active: false,
  matchingCardIds: [],
  distance: null,
};

function isCompanyInRange(company) {
  if (isHeadquarters(company)) {
    return true;
  }

  const cardId = getCompanyCardId(company);
  if (window.map && typeof window.map.getBounds === 'function' && Array.isArray(window.markers) && window.markers.length) {
    const bounds = window.map.getBounds();
    if (bounds) {
      const marker = window.markers.find((item) => item.cardId === cardId);
      if (marker?.position) {
        return bounds.contains(marker.position);
      }
      return false;
    }
  }

  if (window.locationSearchResults?.active) {
    const matchingIds = window.locationSearchResults.matchingCardIds || [];
    if (matchingIds.length) {
      return matchingIds.includes(cardId);
    }
  }

  return true;
}

// Listen for location search completion
window.addEventListener('locationSearchComplete', (event) => {
  window.locationSearchResults = {
    active: true,
    matchingCardIds: event.detail?.matchingCardIds || [],
    radius: event.detail?.radius ?? event.detail?.distance ?? null,
  };
  updateFilters();
});

function initializeFiltering() {
  // Check for URL parameters
  const urlParams = new URLSearchParams(window.location.search);
  const filterParam = urlParams.get('filter');

  // Ensure window.companies is populated
  if (!window.companies || !Array.isArray(window.companies)) {
    window.companies = [];

    // Collect data from DOM elements
    const cards = document.querySelectorAll('.card.company-info-card');
    cards.forEach((card) => {
      if (card.id === 'no-exact-match-message') return;
      window.companies.push({
        name: card.dataset.name,
        make: card.dataset.make,
        model: card.dataset.model,
        vehicleYear: card.dataset.vehicleYear,
        vehicleBedLength: card.dataset.vehicleBedLength,
        vehicleType: card.dataset.vehicleType,
        type: card.dataset.type,
        tags: card.dataset.filter ? card.dataset.filter.split(',') : [],
        visible: true,
        element: card,
      });
    });
  }

  const companyCardsContainer = document.getElementById('company-cards-container');
  noExactMatchMessage = document.getElementById('no-exact-match-message');

  if (!noExactMatchMessage && companyCardsContainer) {
    noExactMatchMessage = document.createElement('div');
    noExactMatchMessage.className = 'no-exact-match-message card company-info-card';
    noExactMatchMessage.id = 'no-exact-match-message';
    noExactMatchMessage.setAttribute('role', 'status');
    noExactMatchMessage.setAttribute('aria-live', 'polite');
    noExactMatchMessage.hidden = true;
    noExactMatchMessage.innerHTML = `
      <div class="no-match-content">
        <p class="no-match-text"></p>
        <button type="button" id="expand-search-button" class="button button--secondary button--tiny" hidden></button>
      </div>
    `;
    companyCardsContainer.insertBefore(noExactMatchMessage, companyCardsContainer.firstChild);
  }

  const expandButton = document.getElementById('expand-search-button');
  if (expandButton && !expandButton.dataset.bound) {
    expandButton.dataset.bound = 'true';
    expandButton.addEventListener('click', handleExpandSearch);
  }

  // Initialize separate filters
  initializeVehicleFilter();
  initializeCheckboxFilter();

  // If URL parameter exists, activate the corresponding filter
  if (filterParam) {
    const filterCheckboxes = document.querySelectorAll('.filter-checkbox input[type="checkbox"]');
    filterCheckboxes.forEach((checkbox) => {
      if (handleize(checkbox.value) === handleize(filterParam)) {
        checkbox.checked = true;
      }
    });
  }

  // Initial update
  updateFilters();
}

function initializeVehicleFilter() {
  const selectFilter = document.querySelector('#vehicle-model-selector');
  if (!selectFilter) return;

  const clearButton = selectFilter.querySelector('.clear__button');
  const vehicleOptions = selectFilter.querySelectorAll('.disclosure__link');

  function clearVehicleFilter() {
    selectedMake = null;
    selectedModel = null;
    selectedVehicleType = null;

    const disclosureButton = selectFilter.querySelector('.disclosure__button');
    const disclosureButtonLabel = disclosureButton?.querySelector('span[data-label]');
    if (disclosureButtonLabel && disclosureButton.dataset.label) {
      disclosureButtonLabel.textContent = disclosureButton.dataset.label;
      delete disclosureButtonLabel.dataset.optionText;
      selectFilter.syncTriggerAccessibleName?.();
    }

    vehicleOptions.forEach((option) => {
      option.classList.remove('selected');
    });

    hideNoExactMatchMessage();

    toggleClearButton();
    updateFilters();
  }

  function toggleClearButton() {
    const disclosureButton = selectFilter.querySelector('.disclosure__button');
    const disclosureButtonLabel = disclosureButton?.querySelector('span[data-label]');
    if (!disclosureButtonLabel) return;
    const defaultLabel = disclosureButton.dataset.label?.toLowerCase();
    const currentLabel = (
      disclosureButtonLabel.dataset.optionText || disclosureButtonLabel.textContent
    )
      .trim()
      .toLowerCase();

    if (clearButton) {
      const hideClear = currentLabel === defaultLabel;
      clearButton.hidden = hideClear;
      clearButton.classList.toggle('hidden', hideClear);
    }
  }

  // Set up vehicle filter events
  clearButton?.addEventListener('click', clearVehicleFilter);

  vehicleOptions.forEach((option) => {
    option.addEventListener('click', function () {
      selectedMake = option.getAttribute('data-make');
      selectedModel = option.getAttribute('data-model');
      selectedVehicleType = option.getAttribute('data-vehicle-type');

      vehicleOptions.forEach((opt) => opt.classList.remove('selected'));
      option.classList.add('selected');

      const disclosureListWrapper = selectFilter.querySelector('.disclosure__list-wrapper');
      const disclosureButton = selectFilter.querySelector('.disclosure__button');
      if (disclosureListWrapper) {
        DisclosurePanel.hide(disclosureListWrapper, disclosureButton);
      }

      toggleClearButton();
      updateFilters();
    });
  });

  toggleClearButton();
}

function initializeCheckboxFilter() {
  filterOptions = document.querySelectorAll('.filter-checkbox input[type="checkbox"]');
  if (!filterOptions.length) return;

  filterOptions.forEach((checkbox) => {
    checkbox.addEventListener('change', updateFilters);
  });
}

function checkVehicleMatch(company) {
  if (isHeadquarters(company)) {
    return true;
  }

  if (!hasVehicleSelection()) {
    return true;
  }

  return checkExactVehicleMatch(company);
}

function checkExactVehicleMatch(company) {
  if (isHeadquarters(company) || !hasVehicleSelection()) {
    return false;
  }

  if (selectedMake && selectedModel) {
    return normalizeMake(company.make) === normalizeMake(selectedMake) && modelsMatch(company.model, selectedModel);
  }

  if (selectedVehicleType) {
    return handleize(company.vehicleType) === handleize(selectedVehicleType);
  }

  return false;
}

function checkSimilarVehicle(company) {
  if (isHeadquarters(company) || !hasVehicleSelection() || checkExactVehicleMatch(company)) {
    return false;
  }

  const typeMatch =
    Boolean(selectedVehicleType) &&
    Boolean(company.vehicleType) &&
    handleize(company.vehicleType) === handleize(selectedVehicleType);
  const makeMatch = Boolean(selectedMake) && Boolean(company.make) && normalizeMake(company.make) === normalizeMake(selectedMake);

  return typeMatch || makeMatch;
}

function hideNoExactMatchMessage() {
  if (!noExactMatchMessage) return;
  noExactMatchMessage.hidden = true;
  noExactMatchMessage.style.display = 'none';
  noExactMatchMessage.classList.remove('no-exact-match-message--similar');
  const expandButton = document.getElementById('expand-search-button');
  if (expandButton) {
    expandButton.hidden = true;
    expandButton.style.display = 'none';
  }
}

function showNoExactMatchMessage(text, { similar = false, showExpand = false } = {}) {
  if (!noExactMatchMessage) return;
  const messageText = noExactMatchMessage.querySelector('.no-match-text');
  const expandButton = document.getElementById('expand-search-button');
  const labels = getFilterMessages();

  if (messageText) {
    messageText.textContent = text;
  }

  noExactMatchMessage.hidden = false;
  noExactMatchMessage.style.display = 'block';
  noExactMatchMessage.classList.toggle('no-exact-match-message--similar', similar);

  if (!expandButton) return;
  if (showExpand) {
    expandButton.hidden = false;
    expandButton.style.display = 'block';
    expandButton.textContent =
      window.searchDistance === Number.MAX_SAFE_INTEGER ? labels.showAll : labels.expand;
  } else {
    expandButton.hidden = true;
    expandButton.style.display = 'none';
  }
}

function checkServiceMatch(company, selectedFilters) {
  // If no filters selected, show everything
  if (!selectedFilters || selectedFilters.length === 0) {
    return true;
  }

  // Get company's filter tags
  const companyTags = company.tags || [];

  // Check if ALL of the selected filters match the company's tags
  return selectedFilters.every((filter) => companyTags.some((tag) => handleize(tag) === handleize(filter)));
}

function updateFilters() {
  if (window._dealerFiltersUpdating) return;
  if (!Array.isArray(window.companies)) {
    console.error('window.companies is not defined or is not an array.');
    return;
  }

  window._dealerFiltersUpdating = true;

  try {
  // Update isInRange property for all companies
  window.companies.forEach((company) => {
    company.isInRange = isCompanyInRange(company);
  });

  const hasServiceFilters = document.querySelector('.filter-checkbox') !== null;
  const hasVehicleFilters = document.querySelector('.vehicle-filter-wrapper') !== null;

  // Get selected service filters
  const selectedCheckboxFilters = hasServiceFilters
    ? Array.from(filterOptions)
        .filter((checkbox) => checkbox.checked)
        .map((checkbox) => checkbox.value.toLowerCase())
    : [];

  // console.log('Selected filters:', selectedCheckboxFilters); // Debug log

  const vehicleFilterActive = hasVehicleFilters && hasVehicleSelection();
  let exactMatchesInRange = 0;
  let similarMatchesInRange = 0;

  window.companies.forEach((company) => {
    if (company.element?.id === 'no-exact-match-message') return;
    if (company.isInRange && !isHeadquarters(company) && checkExactVehicleMatch(company)) {
      exactMatchesInRange++;
    }
  });

  window.companies.forEach((company) => {
    if (company.element?.id === 'no-exact-match-message') return;

    const exactMatch = hasVehicleFilters ? checkExactVehicleMatch(company) : true;
    const similarMatch = hasVehicleFilters ? checkSimilarVehicle(company) : false;
    const vehicleMatch = !vehicleFilterActive || exactMatch || (exactMatchesInRange === 0 && similarMatch);
    const serviceMatch = hasServiceFilters ? checkServiceMatch(company, selectedCheckboxFilters) : true;
    const cardId = getCompanyCardId(company);

    const shouldShow =
      isHeadquarters(company) || (company.isInRange && serviceMatch && vehicleMatch);

    company.visible = shouldShow;

    if (shouldShow) {
      if (company.element) {
        company.element.hidden = false;
        company.element.style.display = 'block';
        if (!isHeadquarters(company) && similarMatch && exactMatchesInRange === 0) {
          similarMatchesInRange++;
        }
      }

      const matchingMarkers = (window.markers || []).filter((m) => m.cardId === cardId);
      matchingMarkers.forEach((marker) => {
        if (marker && !marker.map) {
          marker.setMap(window.map);
        }
      });
    } else {
      if (company.element) {
        company.element.style.display = 'none';
      }
      const matchingMarkers = (window.markers || []).filter((m) => m.cardId === cardId);
      matchingMarkers.forEach((marker) => {
        if (marker && marker.map) {
          marker.setMap(null);
        }
      });
    }
  });

  const labels = getFilterMessages();
  if (!vehicleFilterActive) {
    hideNoExactMatchMessage();
  } else if (exactMatchesInRange === 0 && similarMatchesInRange > 0) {
    showNoExactMatchMessage(labels.similar, { similar: true });
  } else if (exactMatchesInRange === 0) {
    showNoExactMatchMessage(labels.none, { showExpand: Boolean(window.userLocation) });
  } else {
    hideNoExactMatchMessage();
  }
  } finally {
    window._dealerFiltersUpdating = false;
  }
}

function handleExpandSearch() {
  const milesToMeters = 1609.34;
  const expandedDistance = 250 * milesToMeters;

  if (window.userLocation && typeof filterMarkersByDistance === 'function') {
    if (!window.searchDistance || window.searchDistance < expandedDistance) {
      window.searchDistance = expandedDistance;
    } else {
      window.searchDistance = Number.MAX_SAFE_INTEGER;
    }
    filterMarkersByDistance(window.userLocation);
    return;
  }

  updateFilters();
}

document.addEventListener('infoCardsLoaded', function (event) {
  initializeFiltering();
});

function initializeCompaniesData(companiesData) {
  window.companies = companiesData;
  if (typeof initializeUserLocation === 'function') {
    initializeUserLocation();
  }
}

// Add an event listener for when location search updates
document.addEventListener('locationSearchUpdated', function (event) {
  matchingCardIds = event.detail?.matchingCardIds || [];
  updateFilters();
});
